export default __webpack_public_path__ + "static/small-business-accomplishment-2d-29034aed28f1e5b8d9042594b112bfe7.webp";